/**
 * Hook to access environment configuration
 * This provides a centralized way to access environment variables
 */

import { API_BASE_URL } from '@/config';

export const useEnvironment = () => {
  const isDevelopment = import.meta.env.MODE === 'development';
  const isProduction = import.meta.env.MODE === 'production';
  const useMockData = import.meta.env.VITE_USE_MOCK_DATA === 'true';

  return {
    isDevelopment,
    isProduction,
    useMockData,
    apiUrl: API_BASE_URL,
  };
};

export default useEnvironment; 